import $ from "jquery";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Operators extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;

        var operators = Comm.Operators(sid);

        this.state = {
            Operators: operators,
            SelectedOperator: null,
            showMissingNameError: false,
        };

        this.EditOperator = this.EditOperator.bind(this);
        this.NewOperator = this.NewOperator.bind(this);
        this.Save = this.Save.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var operators = this.state.Operators.slice();

        var self = this;

        return Context.HasRight("roperators") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("operators")}</div>
                <div className="panel-body">
                    {Context.HasRight("eoperators") ? (
                        <button className="btn btn-primary" onClick={this.NewOperator}>
                            {Translation.Trans("newoperator")}
                        </button>
                    ) : null}
                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-5">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="90%">{Translation.Trans("name")}</th>
                                        <th width="10%"></th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="scrollableDiv">
                                <table className="table table-striped">
                                    <tbody>
                                        {operators.map((obj) =>
                                            true ? (
                                                <tr>
                                                    <td width="90%">
                                                        <span
                                                            className={
                                                                this.state.SelectedOperator != null &&
                                                                    this.state.SelectedOperator.id ===
                                                                    obj.operator.id
                                                                    ? "btn btn-warning"
                                                                    : null
                                                            }
                                                        >
                                                            <a
                                                                onClick={() => self.EditOperator(obj)}
                                                                className="pointhand"
                                                            >
                                                                {obj.operator.name}
                                                            </a>
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : null
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {this.state.SelectedOperator !== null ? (
                            <div className="col-md-7 borderDiv">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label className="control-label">{Translation.Trans("name")}</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            type="text"
                                            id="tbName"
                                            className="form-control"
                                            defaultValue={this.state.SelectedOperator.name}
                                            key={"name" + this.state.SelectedOperator.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.showMissingNameError ? (
                                            <div className="alert alert-danger">
                                                {Translation.Trans("entervalue")}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label className="control-label">
                                            {Translation.Trans("barcodename")}
                                        </label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            type="text"
                                            id="tbBarcodeName"
                                            className="form-control"
                                            defaultValue={this.state.SelectedOperator.label_name}
                                            key={"barcodename" + this.state.SelectedOperator.id}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label className="control-label">
                                            {Translation.Trans("visible")}
                                        </label>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="checkbox">
                                            <input
                                                id="cbVisible"
                                                type="checkbox"
                                                defaultChecked={this.state.SelectedOperator.visible}
                                                key={"input" + this.state.SelectedOperator.id}
                                            />
                                            <label htmlFor="cbVisible"></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {Context.HasRight("eoperators") ? (
                                        <div className="col-md-12">
                                            <button
                                                className="btn btn-primary pull-right"
                                                onClick={this.Save}
                                            >
                                                {Translation.Trans("save")}
                                            </button>
                                            <button
                                                className="btn btn-info pull-right"
                                                onClick={() => self.Del()}
                                            >
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }

    EditOperator(operator) {
        this.setState({ SelectedOperator: operator.operator });
    }
    NewOperator() {
        this.setState({ SelectedOperator: { visible: true } });
    }

    Save() {
        this.setState({ showMissingNameError: false });
        var canSave = true;
        var name = $("#tbName").val();
        var barcodename = $("#tbBarcodeName").val();
        var visible = $("#cbVisible").prop("checked");

        if (name === "") {
            this.setState({ showMissingNameError: true });
            canSave = false;
        }

        if (!canSave) return;

        var data = {};
        if (this.state.SelectedOperator.hasOwnProperty("id")) {
            data.id = this.state.SelectedOperator.id;
        }
        data.name = name;
        data.label_name = barcodename;
        data.visible = visible;
        var sid = Context.GetContext().Sid;

        var postdata = {
            data: JSON.stringify(data),
            session: sid,
        };
        Comm.SaveOperator(postdata);

        var operators = Comm.Operators(sid);

        this.setState({
            Operators: operators,
            SelectedOperator: null,
            showMissingNameError: false,
        });
    }

    Del() {
        if (window.confirm(Translation.Trans("pleaseconfirm"))) {

            var data = this.state.SelectedOperator;
            var sid = Context.GetContext().Sid;
            data.session = sid;
            data.visible = false;
            Comm.SaveOperator(data);
            this.setState({ SelectedOperator: null });
        }
        //павката не ми го е дал
    }
}

export default Operators;



// WEBPACK FOOTER //
// ./src/pages/operators.js